/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import * as React from 'react';
import { Translation } from 'react-i18next';
import { UptimeTypography } from '@uptime/uptime-component';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { HomePath } from 'utils/routes';
import ChairsWat from 'assets/images/errorBoundary/chairsWat.png';
import {
  UptimeBox,
  UptimeGrid,
  UptimeButton
} from '@uptime/uptime-component';
import { withTranslation } from 'react-i18next';

class ErrorBoundary extends React.Component<RouteComponentProps & { children?: React.ReactNode }> {
  state = {
    error: null,
    pathname: this.props.location.pathname,
  };

  componentDidUpdate() {
    const { location } = this.props;
    const { pathname } = this.state;
    if (pathname !== location.pathname) {
      this.setState({ pathname: location.pathname });
    }
  }

  /*
    - Side effects related to error handling, i.e. logging, should be handled here
    - We will replace the console.error with a call to an error logging service
  */
  componentDidCatch(stackTrace: any): void {
    this.setState((prev: any) => ({ ...prev, error: stackTrace }));
  }

  render(): React.ReactNode {
    const { children, history, location } = this.props;
    const { error, pathname } = this.state;
    if (error) {
      if (pathname !== location.pathname) {
        window.location.reload();
      }
      return (
        <UptimeGrid
          minHeight="100%"
          flexDirection="column"
          paddingY="36px"
          backgroundColor="grayScale.2"
          position="relative"
        >
          <UptimeBox
            backgroundImage={`url(${ChairsWat})`}
            backgroundSize={{ xxs: 'cover', xxl: 'cover' }}
            backgroundPosition="center"
            height={{ xxs: '574px', xs: '974px', sm: '974px', md: '1771px' }}
            width="100%"
            position="absolute"
            bottom="0"
            marginBottom={{
              xxs: '-170px',
              xs: '-295px',
              sm: '-295px',
              md: '-550px',
            }}
          />
          <UptimeGrid
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <UptimeBox
              backgroundColor="grayScale.1"
              width={{ xxs: '298px', xs: '547px' }}
              height={{ xxs: '551px', xs: '800px' }}
              maxWidth="100%"
            >
              <UptimeBox
                // Header
                width="100%"
                height="auto"
              >
                <UptimeBox textAlign="center">
                  <Translation>
                    {t => (
                      <UptimeTypography
                        kind="h1"
                        textAlign="center"
                        fontSize="80px"
                        fontWeight="540"
                        paddingBottom={{ xxs: 0, xs: 4 }}
                      >
                        {t('errorDialog:errorBoundary.title')}
                      </UptimeTypography>
                    )}
                  </Translation>
                </UptimeBox>
                <Translation>
                  {t => (
                    <UptimeTypography
                      kind="h3"
                      textAlign="center"
                      fontSize={{ xxs: 2, xs: '31px' }}
                    >
                      {t('errorDialog:errorBoundary.subtitle')}
                    </UptimeTypography>
                  )}
                </Translation>
              </UptimeBox>
              <UptimeGrid
                // Subheader
                width="100%"
                height="auto"
                justifyContent="center"
              >
                <UptimeBox width="450px">
                  <Translation>
                    {t => (
                      <UptimeTypography
                        kind="h6"
                        fontWeight="normal"
                        textAlign="center"
                        marginTop="18px"
                        fontSize={{ xxs: 1, xs: 2 }}
                        margin={2}
                      >
                        {t('errorDialog:errorBoundary.body')}
                      </UptimeTypography>
                    )}
                  </Translation>
                </UptimeBox>
              </UptimeGrid>
              <UptimeGrid
                flexDirection={{ xxs: 'column-reverse', xs: 'row' }}
                justifyContent="center"
                alignItems="center"
                paddingBottom="60px"
                paddingTop="20px"
              >
                <UptimeBox zIndex={1}>
                  <UptimeButton
                    kind="text"
                    margin={0}
                    padding={2}
                    onClick={() => window.location.reload()}
                  >
                    <Translation>
                      {t => (
                        <UptimeTypography
                          kind="body3"
                          margin={0}
                          paddingLeft={2}
                          paddingRight={2}
                        >
                          {t('errorDialog:errorBoundary.refreshButton')}
                        </UptimeTypography>
                      )}
                    </Translation>
                  </UptimeButton>
                </UptimeBox>
                <UptimeBox zIndex={1}>
                  <UptimeButton
                    kind="impact2"
                    margin={0}
                    marginLeft={{ xxs: 0, xs: 4 }}
                    marginBottom={{ xxs: 3, xs: 0 }}
                    padding={2}
                    onClick={() => {
                      if (location.pathname === HomePath) {
                        window.location.reload();
                      } else {
                        history.push(HomePath);
                      }
                    }}
                  >
                    <Translation>
                      {t => (
                        <UptimeTypography
                          kind="body3"
                          margin={0}
                          paddingLeft={2}
                          paddingRight={2}
                        >
                          {t('errorDialog:errorBoundary.goBackHomeButton')}
                        </UptimeTypography>
                      )}
                    </Translation>
                  </UptimeButton>
                </UptimeBox>
              </UptimeGrid>
            </UptimeBox>
          </UptimeGrid>
        </UptimeGrid>
      );
    }
    return children;
  }
}

export default withTranslation('errorDialog')(withRouter(ErrorBoundary as any));
